/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePortfolioRequest } from '../models/CreatePortfolioRequest';
import type { InviteResult } from '../models/InviteResult';
import type { Portfolio } from '../models/Portfolio';
import type { PortfolioCollaborators } from '../models/PortfolioCollaborators';
import type { PortfolioInviteRequest } from '../models/PortfolioInviteRequest';
import type { PortfolioResult } from '../models/PortfolioResult';
import type { UpdatePortfolioRequest } from '../models/UpdatePortfolioRequest';
import type { UpdatePortfolioResponse } from '../models/UpdatePortfolioResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PortfolioService {

    /**
     * Add an invite for a user to the portfolio.  If the user already has a profile,
     * the profile is immediately added to the portfolio.  Otherwise, an invite is
     * created.
     * @param portfolioId The ID of the portfolio.
     * @param requestBody The request that includes the configuration of the invite.
     * @returns InviteResult OK
     * @throws ApiError
     */
    public static portfolioAddCollaborator(
        portfolioId: string,
        requestBody: PortfolioInviteRequest,
    ): CancelablePromise<InviteResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/portfolios/{portfolioId}/collaborators/add',
            path: {
                'portfolioId': portfolioId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Creates a new portfolio.
     * @param requestBody The request to create a portfolio.
     * @returns Portfolio OK
     * @throws ApiError
     */
    public static createPortfolio(
        requestBody?: CreatePortfolioRequest,
    ): CancelablePromise<Portfolio> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/portfolios/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Deletes a portfolio.
     * @param portfolioId The ID of the project to run.
     * @returns Portfolio OK
     * @throws ApiError
     */
    public static deletePortfolio(
        portfolioId: string,
    ): CancelablePromise<Portfolio> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/portfolios/{portfolioId}/delete',
            path: {
                'portfolioId': portfolioId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieves the collaborators and the invites for a given portfolio.
     * @param portfolioId The ID of the portfolio.
     * @returns PortfolioCollaborators OK
     * @throws ApiError
     */
    public static portfolioGetCollaborators(
        portfolioId: string,
    ): CancelablePromise<PortfolioCollaborators> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/portfolios/{portfolioId}/collaborators',
            path: {
                'portfolioId': portfolioId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Retrieves the portfolios for a given user where the user created the portfolio,
     * is a member of the portfolio, or has an invite to the portfolio.
     * @returns PortfolioResult OK
     * @throws ApiError
     */
    public static getUserPortfolios(): CancelablePromise<Array<PortfolioResult>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/portfolios/list',
        });
    }

    /**
     * Creates a new portfolio.
     * @param portfolioId The ID of the portfolio to update.
     * @param requestBody The request to create a portfolio.
     * @returns UpdatePortfolioResponse OK
     * @throws ApiError
     */
    public static updatePortfolio(
        portfolioId: string,
        requestBody?: UpdatePortfolioRequest,
    ): CancelablePromise<UpdatePortfolioResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/portfolios/{portfolioId}/update',
            path: {
                'portfolioId': portfolioId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all portfolios that the user belongs to either as a creator or
     * as a member of the organization.
     * @param organizationId The ID of the organization to scope the Portfolios for.
     * @returns PortfolioResult OK
     * @throws ApiError
     */
    public static getPortfolios(
        organizationId: string,
    ): CancelablePromise<Array<PortfolioResult>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/portfolios/{organizationId}',
            path: {
                'organizationId': organizationId,
            },
        });
    }

}
